// 测试
module.exports = {
  title: '政策通',
  baseUrl: '/', // 正式项目地址
  baseApi: 'https://zjtxclub.cdiedc.com', // api请求地址,注意：如果你使用了代理，请设置成'/',
  baseApiUpload: "http://ddns.cdiedc.com:8090",
  baseWss: "wss://hycb.hoteas.com/app/",
  APPID: 'wx68551eb4818fd00e',
  APPSECRET: 'xxx',
  $cdn: '',
  ZqcUrl: '/zqclj/#/home',
  ZqcUrlMatterCon: '/zqclj/#/matterCon',
  ZqcUrlCompanyone: '/zqclj/#/companytwo',
  phoneService: '18080079892',//睿方公司电话
  // phoneServiceContent: ["这是您首次联系这位会员，为了避免唐突，首次联系会由俱乐部秘书处为您牵线搭桥。", "俱乐部会为您做预约和引荐工作，在获得对方同意后，俱乐部会为您们的首次联系创建最佳交流氛围。"],
  phoneServiceContent: ["您尚未成为俱乐部的正式会员，建议您及时联系您的专属秘书，加入俱乐部，之后俱乐部会为您们相互引荐。", "点击继续，您可以直接电话联系您的专属秘书。"],
  phoneServiceContentVIP: ["已收到您的联系请求，俱乐部会为您做预约和引荐工作。在获得对方同意后，俱乐部会为您们的联系创建最佳交流氛围。", "点击继续，您可以直接电话联系您的专属秘书。"],
  vipExpire: '为避免您的人脉流失，建议您及时联系的您的专属俱乐部会员秘书完成续费。或致电俱乐部会员服务中心陈老师：<a href="tel:18080079892" style="color: #0066ff">18080079892 </a></p>',
  followError: '<p>您现在是临时会员，最多只能关注3名俱乐部成员，目前您已经关注过3名会员了。</p><p> 为了扩展您的人脉，建议您联系的您的专属俱乐部会员秘书，或致电俱乐部会员服务中心陈老师：<a href="tel:18080079892" style="color: #0066ff">18080079892 </a>，成为正式会员，之后将不再受此限制。</p> '
}
